export default import.meta.ROLLDOWN_FILE_URL_G7OEYHjKkuF9sexiWM$FJA